import { render, staticRenderFns } from "./ArtSpaceExhibitions.vue?vue&type=template&id=2d4f46c6&scoped=true&"
import script from "./ArtSpaceExhibitions.vue?vue&type=script&lang=js&"
export * from "./ArtSpaceExhibitions.vue?vue&type=script&lang=js&"
import style0 from "./ArtSpaceExhibitions.vue?vue&type=style&index=0&id=2d4f46c6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d4f46c6",
  null
  
)

export default component.exports